import axios from 'axios';

const instance = new axios.create({
  xsrfCookieName: 'CRAFT_CSRF_TOKEN',
  xsrfHeaderName: 'X-CSRF-Token',
})

instance.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
instance.defaults.headers['X-HTTP_X_REQUESTED_WITH-With'] = 'XMLHttpRequest'

export default instance
